import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// @ts-ignore
import { getRedirectUrl } from 'lib/src/redux/selectors/redirects';
import { useCallback, useEffect } from 'react';
import { setRedirectUrl } from 'lib/src/redux/actions/redirects';

export default function useGlobalRedirect(): void {
    const dispatch = useDispatch();
    const history = useHistory();
    const redirectUrl: string | null = useSelector(getRedirectUrl);

    const resetRedirect = useCallback(() => {
        const url = redirectUrl;
        if (url) {
            console.log('redirecting to:', url, ' because of useGlobalRedirect');
            dispatch(setRedirectUrl(null));
            history.push(url);
        }
    }, [dispatch, history, redirectUrl]);

    useEffect(resetRedirect, [resetRedirect]);
}
